import produce from "immer";

import * as actionTypes from '../actions/actionTypes';
import {BOOKING_LIST_SET_DATE} from "../actions/actionTypes";

const initialState = {
    count_active: '',
    count_archived: '',
    count_trashed: '',
    bookings: [],
    keyword: false,
    status: 'active',
    date: '',
    sortColumn: '',
    sortMode: '',
    page: 1, // for now, filter and page are supported for groups only
    filter: 0,
    archivedIds: [],
    trashIds: [],
    smsSendingIds: [],
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.BOOKING_LIST_SET_STATUS:
            return {
                ...state,
                status: action.status ?? 'active',
                date: action.date,
                sortColumn: action.sortColumn,
                sortMode: action.sortMode,
            };
        case actionTypes.BOOKING_LIST_SET_PAGE:
            return {
                ...state,
                page: action.page
            }
        case actionTypes.BOOKING_LIST_SET_DATE:
            return {
                ...state,
                date: action.date
            }
        case actionTypes.BOOKING_LIST_SET_SORT:
            return {
                ...state,
                sortColumn: action.sortColumn,
                sortMode: action.sortMode,
            };
        case actionTypes.BOOKING_LIST_SET_KEYWORD:
            return {
                ...state,
                keyword: action.keyword,
                date: action.date,
                status: action.status,
                sortColumn: action.sortColumn,
                sortMode: action.sortMode,
            };
        case actionTypes.BOOKING_LIST_SET:
            return {
                ...state,
                // page: 1,
                totalPages: null,
                ...action
            };
        case actionTypes.BOOKING_UPDATE:
            return {
                ...state,
                bookings: state.bookings.filter(value => value.id !== action.booking.id),
                count_active: action.counters.count_active ?? state.count_active,
                count_archived: action.counters.count_archived ?? state.count_archived,
                count_trashed: action.counters.count_trashed ?? state.count_trashed
            };
        case actionTypes.BOOKING_ARCHIVED_START:
            return {
                ...state,
                archivedIds: [...state.archivedIds, action.id]
            }
        case actionTypes.BOOKING_ARCHIVED_DONE:
            return {
                ...state,
                archivedIds: state.archivedIds.filter(value => value !== action.id)
            }
        case actionTypes.BOOKING_TRASH_START:
            return {
                ...state,
                trashIds: [...state.trashIds, action.id]
            }
        case actionTypes.BOOKING_TRASH_DONE:
            return {
                ...state,
                trashIds: state.trashIds.filter(value => value !== action.id)
            }
        case actionTypes.BOOKING_SMS_SEND_START:
            return {
                ...state,
                smsSendingIds: [...state.smsSendingIds, action.id]
            }
        case actionTypes.BOOKING_SMS_SEND_DONE:
            return {
                ...state,
                smsSendingIds: state.smsSendingIds.filter(value => value !== action.id)
            }
        case actionTypes.BOOKING_REPLACE:
            return {
                ...state,
                bookings: state.bookings.map(b => b.id === action.booking.id ? {...b, ...action.booking} : b)
            }
        default:
            return state;
    }
}

export default reducer;